<template>
  <v-app id="backGND">
    <navBar />
    <div id="triangle_down">
      <div id="triangle">
        <h1
          class="rotate"
          style="
            margin: auto;
            text-align: left;
            font-family: 'Poiret One', sans-serif;
            color: white;
            padding-left: 1rem;
            font-size: 3rem;
          "
        >
          Precios
        </h1>
      </div>
    </div>

    <pricingCard />
  </v-app>
</template>
<script>
import navBar from "@/components/navbar";
import pricingCard from "@/components/pricing_page_components/pricing_card";
export default {
  components: { navBar, pricingCard },
};
</script>
<style scoped>
#backGND {
  background-image: url("../assets/back.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: auto;
}
#triangle_down {
  height: 10rem;

  background: linear-gradient(
    to top right,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    rgba(200, 200, 200, 1) 50%,
    rgba(200, 200, 200, 1) 100%
  );
}
#triangle {
  height: 10rem;
  background: linear-gradient(
    to top left,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    #000000 50%,
    #000000 100%
  );
}
.rotate {
  transform: rotate(-5deg);
}
</style>



// WEBPACK FOOTER //
// src/components/pricingpage.vue